import * as Yup from "yup";

export const UnitSizeSchema = Yup.object().shape({
  description: Yup.string().required("Description is required"),
});
